import { ActionTypes } from '../types/actionTypes';
import {
  ISetOkpd2,
  IClear,
  ISetMsp,
  ISetRadius,
  ISetRegions,
  ISetRpn,
  ISetAdvancedSearchValue,
  ISetLimit,
  ISetSortParticipation,
  ISetSortVictories,
  // new
  ISetOkpd2Data,
  ISearchOkpd2Data,
  ISetProcedureBidsCountBuyer,
  ISetBidsRegionProcedureBidsCount,
  ISetTagsProcedureBidsCount,
  ISetOKPD2WonProcedureBidsCount,
  ISetLinkedBuyerDescription,
  ISetRegionsByInn,
  ISetBidsRegion,
} from '../types/actions';

export const setAdvancedSearchValue = (payload: string): ISetAdvancedSearchValue => ({
  type: ActionTypes.SET_ADVANCED_SEARCH_VALUE,
  payload,
});
export const setOkpd2 = (payload: string[]): ISetOkpd2 => ({
  type: ActionTypes.SET_OKPD2,
  payload,
});
// new
export const setOkpd2Data = (payload: any): ISetOkpd2Data => ({
  type: ActionTypes.SET_OKPD2_DATA,
  payload,
});

export const searchOkpd2Data = (payload: any): ISearchOkpd2Data => ({
  type: ActionTypes.SEARCH_OKPD2_DATA,
  payload,
});

// end new
export const setRegions = (payload: string[]): ISetRegions => ({
  type: ActionTypes.SET_REGION,
  payload,
});
export const setRadius = (payload: number): ISetRadius => ({
  type: ActionTypes.SET_RADIUS,
  payload,
});
export const setMsp = (payload: number): ISetMsp => ({
  type: ActionTypes.SET_MSP,
  payload,
});
export const setRpn = (payload: number): ISetRpn => ({
  type: ActionTypes.SET_RPN,
  payload,
});
export const setSortParticipation = (payload: number): ISetSortParticipation => ({
  type: ActionTypes.SET_SORT_PARTICIPATION,
  payload,
});

export const setSortVictories = (payload: number): ISetSortVictories => ({
  type: ActionTypes.SET_SORT_VICTORIES,
  payload,
});
// export const setSort = (payload: string): ISetSort => {
//   return { type: ActionTypes.SET_SORT, payload };
// };

export const setLimit = (payload: number): ISetLimit => ({
  type: ActionTypes.SET_LIMIT,
  payload,
});

export const clear = (): IClear => ({
  type: ActionTypes.CLEAR,
});
export const setProcedureBidsCountBuyer = (payload: number): ISetProcedureBidsCountBuyer => ({
  type: ActionTypes.SET_PROCEDURE_BIDS_COUNT_FOR_BUYER,
  payload,
});

export const setBidsRegionProcedureBidsCount = (payload: number): ISetBidsRegionProcedureBidsCount => ({
  type: ActionTypes.SET_BIDS_REGION_PROCEDURE_BIDS_COUNT,
  payload,
});

export const setTagsProcedureBidsCount = (payload: number): ISetTagsProcedureBidsCount => ({
  type: ActionTypes.SET_TAGS_PROCEDURE_BIDS_COUNT,
  payload,
});

export const setOKPD2WonProcedureBidsCount = (payload: number): ISetOKPD2WonProcedureBidsCount => ({
  type: ActionTypes.SET_OKPD2_WON_PROCEDURE_BIDS_COUNT,
  payload,
});
export const setLinkedBuyerDescription = (payload: string): ISetLinkedBuyerDescription => ({
  type: ActionTypes.SET_LINKED_BUYER_DESCRIPTION,
  payload,
});
export const setRegionsByInn = (payload: string[]): ISetRegionsByInn => ({
  type: ActionTypes.SET_REGIONS_BY_INN,
  payload,
});
export const setBidsRegions = (payload: string[]): ISetBidsRegion => ({
  type: ActionTypes.SET_BIDS_REGIONS,
  payload,
});